/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Admin_rootRouteImport } from './routes/admin/__root'
import { Route as OperationsOrganizations_rootRouteImport } from './routes/operations/organizations/__root'
import { Route as AdminOrganizations_rootRouteImport } from './routes/admin/organizations/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SalesRouteImport } from './routes/sales'
import { Route as OperationsRouteImport } from './routes/operations'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GmRouteImport } from './routes/gm'
import { Route as ClientRouteImport } from './routes/client'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SalesIndexRouteImport } from './routes/sales/index'
import { Route as OperationsIndexRouteImport } from './routes/operations/index'
import { Route as GmIndexRouteImport } from './routes/gm/index'
import { Route as ClientIndexRouteImport } from './routes/client/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SalesProfileRouteImport } from './routes/sales/profile'
import { Route as QuotesQuoteIdRouteImport } from './routes/quotes.$quoteId'
import { Route as OperationsSettingsRouteImport } from './routes/operations/settings'
import { Route as OperationsProfileRouteImport } from './routes/operations/profile'
import { Route as GmProfileRouteImport } from './routes/gm/profile'
import { Route as ClientSettingsRouteImport } from './routes/client/settings'
import { Route as ClientProfileRouteImport } from './routes/client/profile'
import { Route as ClientDashboardRouteImport } from './routes/client/dashboard'
import { Route as ClientAddressBookRouteImport } from './routes/client/address-book'
import { Route as AdminZoningRouteImport } from './routes/admin/zoning'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTailgateCostPalletRouteImport } from './routes/admin/tailgate-cost-pallet'
import { Route as AdminTailgateCostCbmRouteImport } from './routes/admin/tailgate-cost-cbm'
import { Route as AdminTailgateCostRouteImport } from './routes/admin/tailgate-cost'
import { Route as AdminSystemLogsRouteImport } from './routes/admin/system-logs'
import { Route as AdminProfileRouteImport } from './routes/admin/profile'
import { Route as AdminPickupCostRouteImport } from './routes/admin/pickup-cost'
import { Route as AdminLinehaulCostRouteImport } from './routes/admin/linehaul-cost'
import { Route as AdminFuelSurchargeRouteImport } from './routes/admin/fuel-surcharge'
import { Route as AdminDeliveryCostRouteImport } from './routes/admin/delivery-cost'
import { Route as AdminCrossdockCostRouteImport } from './routes/admin/crossdock-cost'
import { Route as AdminAddressesRouteImport } from './routes/admin/addresses'
import { Route as SalesQuotesIndexRouteImport } from './routes/sales/quotes/index'
import { Route as OperationsQuotesIndexRouteImport } from './routes/operations/quotes/index'
import { Route as OperationsOrganizationsIndexRouteImport } from './routes/operations/organizations/index'
import { Route as OperationsItemsIndexRouteImport } from './routes/operations/items/index'
import { Route as GmQuotesIndexRouteImport } from './routes/gm/quotes/index'
import { Route as ClientQuotesIndexRouteImport } from './routes/client/quotes/index'
import { Route as ClientAddressBookIndexRouteImport } from './routes/client/address-book/index'
import { Route as AdminZoningIndexRouteImport } from './routes/admin/zoning/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminSystemLogsIndexRouteImport } from './routes/admin/system-logs/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminQuotesIndexRouteImport } from './routes/admin/quotes/index'
import { Route as AdminPostCodeIndexRouteImport } from './routes/admin/post-code/index'
import { Route as AdminPickupCostIndexRouteImport } from './routes/admin/pickup-cost/index'
import { Route as AdminPickupCostPalletIndexRouteImport } from './routes/admin/pickup-cost-pallet/index'
import { Route as AdminPickupCostCbmIndexRouteImport } from './routes/admin/pickup-cost-cbm/index'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as AdminLinehaulCostIndexRouteImport } from './routes/admin/linehaul-cost/index'
import { Route as AdminItemsIndexRouteImport } from './routes/admin/items/index'
import { Route as AdminFuelSurchargeIndexRouteImport } from './routes/admin/fuel-surcharge/index'
import { Route as AdminDeliveryCostIndexRouteImport } from './routes/admin/delivery-cost/index'
import { Route as AdminCrossdockCostIndexRouteImport } from './routes/admin/crossdock-cost/index'
import { Route as AdminAssistantIndexRouteImport } from './routes/admin/assistant/index'
import { Route as AdminAddressesIndexRouteImport } from './routes/admin/addresses/index'
import { Route as SalesQuotesIdRouteImport } from './routes/sales/quotes/$id'
import { Route as OperationsQuotesNewRouteImport } from './routes/operations/quotes/new'
import { Route as OperationsQuotesIdRouteImport } from './routes/operations/quotes/$id'
import { Route as OperationsOrganizationsIdRouteImport } from './routes/operations/organizations/$id'
import { Route as GmQuotesIdRouteImport } from './routes/gm/quotes/$id'
import { Route as ClientQuotesNewRouteImport } from './routes/client/quotes/new'
import { Route as ClientQuotesIdRouteImport } from './routes/client/quotes/$id'
import { Route as AdminSystemLogsIdRouteImport } from './routes/admin/system-logs/$id'
import { Route as AdminQuotesNewRouteImport } from './routes/admin/quotes/new'
import { Route as AdminQuotesIdRouteImport } from './routes/admin/quotes/$id'
import { Route as AdminOrganizationsIdRouteImport } from './routes/admin/organizations/$id'
import { Route as AdminFuelSurchargeImportRouteImport } from './routes/admin/fuel-surcharge/import'
import { Route as SalesQuotesIdIndexRouteImport } from './routes/sales/quotes/$id.index'
import { Route as OperationsQuotesIdIndexRouteImport } from './routes/operations/quotes/$id.index'
import { Route as GmQuotesIdIndexRouteImport } from './routes/gm/quotes/$id.index'
import { Route as ClientQuotesIdIndexRouteImport } from './routes/client/quotes/$id.index'
import { Route as AdminSystemSettingsPalletBandsIndexRouteImport } from './routes/admin/system-settings/pallet-bands/index'
import { Route as AdminSystemSettingsGeneralIndexRouteImport } from './routes/admin/system-settings/general/index'
import { Route as AdminSystemSettingsCbmBandsIndexRouteImport } from './routes/admin/system-settings/cbm-bands/index'
import { Route as AdminQuotesIdIndexRouteImport } from './routes/admin/quotes/$id.index'
import { Route as AdminDeliveryCostPalletIndexRouteImport } from './routes/admin/delivery-cost/pallet/index'
import { Route as AdminDeliveryCostCbmIndexRouteImport } from './routes/admin/delivery-cost/cbm/index'
import { Route as SalesQuotesIdEditRouteImport } from './routes/sales/quotes/$id.edit'
import { Route as OperationsQuotesIdEditRouteImport } from './routes/operations/quotes/$id.edit'
import { Route as GmQuotesIdEditRouteImport } from './routes/gm/quotes/$id.edit'
import { Route as ClientQuotesIdEditRouteImport } from './routes/client/quotes/$id.edit'
import { Route as AdminQuotesIdEditRouteImport } from './routes/admin/quotes/$id.edit'

const Admin_rootRoute = Admin_rootRouteImport.update({
  id: '/__root',
  getParentRoute: () => AdminRoute,
} as any)
const OperationsOrganizations_rootRoute =
  OperationsOrganizations_rootRouteImport.update({
    id: '/organizations/__root',
    getParentRoute: () => OperationsRoute,
  } as any)
const AdminOrganizations_rootRoute = AdminOrganizations_rootRouteImport.update({
  id: '/organizations/__root',
  getParentRoute: () => AdminRoute,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesRoute = SalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRoute = OperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GmRoute = GmRouteImport.update({
  id: '/gm',
  path: '/gm',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRoute = ClientRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesIndexRoute = SalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesRoute,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperationsRoute,
} as any)
const GmIndexRoute = GmIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GmRoute,
} as any)
const ClientIndexRoute = ClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SalesProfileRoute = SalesProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SalesRoute,
} as any)
const QuotesQuoteIdRoute = QuotesQuoteIdRouteImport.update({
  id: '/quotes/$quoteId',
  path: '/quotes/$quoteId',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsSettingsRoute = OperationsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OperationsRoute,
} as any)
const OperationsProfileRoute = OperationsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OperationsRoute,
} as any)
const GmProfileRoute = GmProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => GmRoute,
} as any)
const ClientSettingsRoute = ClientSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ClientRoute,
} as any)
const ClientProfileRoute = ClientProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ClientRoute,
} as any)
const ClientDashboardRoute = ClientDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ClientRoute,
} as any)
const ClientAddressBookRoute = ClientAddressBookRouteImport.update({
  id: '/address-book',
  path: '/address-book',
  getParentRoute: () => ClientRoute,
} as any)
const AdminZoningRoute = AdminZoningRouteImport.update({
  id: '/zoning',
  path: '/zoning',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTailgateCostPalletRoute = AdminTailgateCostPalletRouteImport.update({
  id: '/tailgate-cost-pallet',
  path: '/tailgate-cost-pallet',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTailgateCostCbmRoute = AdminTailgateCostCbmRouteImport.update({
  id: '/tailgate-cost-cbm',
  path: '/tailgate-cost-cbm',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTailgateCostRoute = AdminTailgateCostRouteImport.update({
  id: '/tailgate-cost',
  path: '/tailgate-cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemLogsRoute = AdminSystemLogsRouteImport.update({
  id: '/system-logs',
  path: '/system-logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPickupCostRoute = AdminPickupCostRouteImport.update({
  id: '/pickup-cost',
  path: '/pickup-cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLinehaulCostRoute = AdminLinehaulCostRouteImport.update({
  id: '/linehaul-cost',
  path: '/linehaul-cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFuelSurchargeRoute = AdminFuelSurchargeRouteImport.update({
  id: '/fuel-surcharge',
  path: '/fuel-surcharge',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeliveryCostRoute = AdminDeliveryCostRouteImport.update({
  id: '/delivery-cost',
  path: '/delivery-cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCrossdockCostRoute = AdminCrossdockCostRouteImport.update({
  id: '/crossdock-cost',
  path: '/crossdock-cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAddressesRoute = AdminAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AdminRoute,
} as any)
const SalesQuotesIndexRoute = SalesQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => SalesRoute,
} as any)
const OperationsQuotesIndexRoute = OperationsQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => OperationsRoute,
} as any)
const OperationsOrganizationsIndexRoute =
  OperationsOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => OperationsRoute,
  } as any)
const OperationsItemsIndexRoute = OperationsItemsIndexRouteImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => OperationsRoute,
} as any)
const GmQuotesIndexRoute = GmQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => GmRoute,
} as any)
const ClientQuotesIndexRoute = ClientQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientAddressBookIndexRoute = ClientAddressBookIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientAddressBookRoute,
} as any)
const AdminZoningIndexRoute = AdminZoningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminZoningRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminSystemLogsIndexRoute = AdminSystemLogsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSystemLogsRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuotesIndexRoute = AdminQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPostCodeIndexRoute = AdminPostCodeIndexRouteImport.update({
  id: '/post-code/',
  path: '/post-code/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPickupCostIndexRoute = AdminPickupCostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPickupCostRoute,
} as any)
const AdminPickupCostPalletIndexRoute =
  AdminPickupCostPalletIndexRouteImport.update({
    id: '/pickup-cost-pallet/',
    path: '/pickup-cost-pallet/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPickupCostCbmIndexRoute = AdminPickupCostCbmIndexRouteImport.update({
  id: '/pickup-cost-cbm/',
  path: '/pickup-cost-cbm/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLinehaulCostIndexRoute = AdminLinehaulCostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLinehaulCostRoute,
} as any)
const AdminItemsIndexRoute = AdminItemsIndexRouteImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFuelSurchargeIndexRoute = AdminFuelSurchargeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFuelSurchargeRoute,
} as any)
const AdminDeliveryCostIndexRoute = AdminDeliveryCostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminDeliveryCostRoute,
} as any)
const AdminCrossdockCostIndexRoute = AdminCrossdockCostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminCrossdockCostRoute,
} as any)
const AdminAssistantIndexRoute = AdminAssistantIndexRouteImport.update({
  id: '/assistant/',
  path: '/assistant/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAddressesIndexRoute = AdminAddressesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAddressesRoute,
} as any)
const SalesQuotesIdRoute = SalesQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => SalesRoute,
} as any)
const OperationsQuotesNewRoute = OperationsQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => OperationsRoute,
} as any)
const OperationsQuotesIdRoute = OperationsQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => OperationsRoute,
} as any)
const OperationsOrganizationsIdRoute =
  OperationsOrganizationsIdRouteImport.update({
    id: '/organizations/$id',
    path: '/organizations/$id',
    getParentRoute: () => OperationsRoute,
  } as any)
const GmQuotesIdRoute = GmQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => GmRoute,
} as any)
const ClientQuotesNewRoute = ClientQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => ClientRoute,
} as any)
const ClientQuotesIdRoute = ClientQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => ClientRoute,
} as any)
const AdminSystemLogsIdRoute = AdminSystemLogsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminSystemLogsRoute,
} as any)
const AdminQuotesNewRoute = AdminQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuotesIdRoute = AdminQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsIdRoute = AdminOrganizationsIdRouteImport.update({
  id: '/organizations/$id',
  path: '/organizations/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFuelSurchargeImportRoute =
  AdminFuelSurchargeImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AdminFuelSurchargeRoute,
  } as any)
const SalesQuotesIdIndexRoute = SalesQuotesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesQuotesIdRoute,
} as any)
const OperationsQuotesIdIndexRoute = OperationsQuotesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperationsQuotesIdRoute,
} as any)
const GmQuotesIdIndexRoute = GmQuotesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GmQuotesIdRoute,
} as any)
const ClientQuotesIdIndexRoute = ClientQuotesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientQuotesIdRoute,
} as any)
const AdminSystemSettingsPalletBandsIndexRoute =
  AdminSystemSettingsPalletBandsIndexRouteImport.update({
    id: '/system-settings/pallet-bands/',
    path: '/system-settings/pallet-bands/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSystemSettingsGeneralIndexRoute =
  AdminSystemSettingsGeneralIndexRouteImport.update({
    id: '/system-settings/general/',
    path: '/system-settings/general/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSystemSettingsCbmBandsIndexRoute =
  AdminSystemSettingsCbmBandsIndexRouteImport.update({
    id: '/system-settings/cbm-bands/',
    path: '/system-settings/cbm-bands/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminQuotesIdIndexRoute = AdminQuotesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminQuotesIdRoute,
} as any)
const AdminDeliveryCostPalletIndexRoute =
  AdminDeliveryCostPalletIndexRouteImport.update({
    id: '/pallet/',
    path: '/pallet/',
    getParentRoute: () => AdminDeliveryCostRoute,
  } as any)
const AdminDeliveryCostCbmIndexRoute =
  AdminDeliveryCostCbmIndexRouteImport.update({
    id: '/cbm/',
    path: '/cbm/',
    getParentRoute: () => AdminDeliveryCostRoute,
  } as any)
const SalesQuotesIdEditRoute = SalesQuotesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => SalesQuotesIdRoute,
} as any)
const OperationsQuotesIdEditRoute = OperationsQuotesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OperationsQuotesIdRoute,
} as any)
const GmQuotesIdEditRoute = GmQuotesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => GmQuotesIdRoute,
} as any)
const ClientQuotesIdEditRoute = ClientQuotesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ClientQuotesIdRoute,
} as any)
const AdminQuotesIdEditRoute = AdminQuotesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AdminQuotesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof Admin_rootRoute
  '/client': typeof ClientRouteWithChildren
  '/gm': typeof GmRouteWithChildren
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/operations': typeof OperationsRouteWithChildren
  '/sales': typeof SalesRouteWithChildren
  '/terms': typeof TermsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/admin/addresses': typeof AdminAddressesRouteWithChildren
  '/admin/crossdock-cost': typeof AdminCrossdockCostRouteWithChildren
  '/admin/delivery-cost': typeof AdminDeliveryCostRouteWithChildren
  '/admin/fuel-surcharge': typeof AdminFuelSurchargeRouteWithChildren
  '/admin/linehaul-cost': typeof AdminLinehaulCostRouteWithChildren
  '/admin/pickup-cost': typeof AdminPickupCostRouteWithChildren
  '/admin/profile': typeof AdminProfileRoute
  '/admin/system-logs': typeof AdminSystemLogsRouteWithChildren
  '/admin/tailgate-cost': typeof AdminTailgateCostRoute
  '/admin/tailgate-cost-cbm': typeof AdminTailgateCostCbmRoute
  '/admin/tailgate-cost-pallet': typeof AdminTailgateCostPalletRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/zoning': typeof AdminZoningRouteWithChildren
  '/client/address-book': typeof ClientAddressBookRouteWithChildren
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/settings': typeof ClientSettingsRoute
  '/gm/profile': typeof GmProfileRoute
  '/operations/profile': typeof OperationsProfileRoute
  '/operations/settings': typeof OperationsSettingsRoute
  '/quotes/$quoteId': typeof QuotesQuoteIdRoute
  '/sales/profile': typeof SalesProfileRoute
  '/admin/': typeof AdminIndexRoute
  '/client/': typeof ClientIndexRoute
  '/gm/': typeof GmIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/admin/fuel-surcharge/import': typeof AdminFuelSurchargeImportRoute
  '/admin/organizations/$id': typeof AdminOrganizationsIdRoute
  '/admin/organizations': typeof AdminOrganizations_rootRoute
  '/admin/quotes/$id': typeof AdminQuotesIdRouteWithChildren
  '/admin/quotes/new': typeof AdminQuotesNewRoute
  '/admin/system-logs/$id': typeof AdminSystemLogsIdRoute
  '/client/quotes/$id': typeof ClientQuotesIdRouteWithChildren
  '/client/quotes/new': typeof ClientQuotesNewRoute
  '/gm/quotes/$id': typeof GmQuotesIdRouteWithChildren
  '/operations/organizations/$id': typeof OperationsOrganizationsIdRoute
  '/operations/organizations': typeof OperationsOrganizations_rootRoute
  '/operations/quotes/$id': typeof OperationsQuotesIdRouteWithChildren
  '/operations/quotes/new': typeof OperationsQuotesNewRoute
  '/sales/quotes/$id': typeof SalesQuotesIdRouteWithChildren
  '/admin/addresses/': typeof AdminAddressesIndexRoute
  '/admin/assistant/': typeof AdminAssistantIndexRoute
  '/admin/crossdock-cost/': typeof AdminCrossdockCostIndexRoute
  '/admin/delivery-cost/': typeof AdminDeliveryCostIndexRoute
  '/admin/fuel-surcharge/': typeof AdminFuelSurchargeIndexRoute
  '/admin/items/': typeof AdminItemsIndexRoute
  '/admin/linehaul-cost/': typeof AdminLinehaulCostIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/pickup-cost-cbm/': typeof AdminPickupCostCbmIndexRoute
  '/admin/pickup-cost-pallet/': typeof AdminPickupCostPalletIndexRoute
  '/admin/pickup-cost/': typeof AdminPickupCostIndexRoute
  '/admin/post-code/': typeof AdminPostCodeIndexRoute
  '/admin/quotes/': typeof AdminQuotesIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/system-logs/': typeof AdminSystemLogsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/zoning/': typeof AdminZoningIndexRoute
  '/client/address-book/': typeof ClientAddressBookIndexRoute
  '/client/quotes/': typeof ClientQuotesIndexRoute
  '/gm/quotes/': typeof GmQuotesIndexRoute
  '/operations/items/': typeof OperationsItemsIndexRoute
  '/operations/organizations/': typeof OperationsOrganizationsIndexRoute
  '/operations/quotes/': typeof OperationsQuotesIndexRoute
  '/sales/quotes/': typeof SalesQuotesIndexRoute
  '/admin/quotes/$id/edit': typeof AdminQuotesIdEditRoute
  '/client/quotes/$id/edit': typeof ClientQuotesIdEditRoute
  '/gm/quotes/$id/edit': typeof GmQuotesIdEditRoute
  '/operations/quotes/$id/edit': typeof OperationsQuotesIdEditRoute
  '/sales/quotes/$id/edit': typeof SalesQuotesIdEditRoute
  '/admin/delivery-cost/cbm/': typeof AdminDeliveryCostCbmIndexRoute
  '/admin/delivery-cost/pallet/': typeof AdminDeliveryCostPalletIndexRoute
  '/admin/quotes/$id/': typeof AdminQuotesIdIndexRoute
  '/admin/system-settings/cbm-bands/': typeof AdminSystemSettingsCbmBandsIndexRoute
  '/admin/system-settings/general/': typeof AdminSystemSettingsGeneralIndexRoute
  '/admin/system-settings/pallet-bands/': typeof AdminSystemSettingsPalletBandsIndexRoute
  '/client/quotes/$id/': typeof ClientQuotesIdIndexRoute
  '/gm/quotes/$id/': typeof GmQuotesIdIndexRoute
  '/operations/quotes/$id/': typeof OperationsQuotesIdIndexRoute
  '/sales/quotes/$id/': typeof SalesQuotesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/terms': typeof TermsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/admin': typeof AdminIndexRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/tailgate-cost': typeof AdminTailgateCostRoute
  '/admin/tailgate-cost-cbm': typeof AdminTailgateCostCbmRoute
  '/admin/tailgate-cost-pallet': typeof AdminTailgateCostPalletRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/settings': typeof ClientSettingsRoute
  '/gm/profile': typeof GmProfileRoute
  '/operations/profile': typeof OperationsProfileRoute
  '/operations/settings': typeof OperationsSettingsRoute
  '/quotes/$quoteId': typeof QuotesQuoteIdRoute
  '/sales/profile': typeof SalesProfileRoute
  '/client': typeof ClientIndexRoute
  '/gm': typeof GmIndexRoute
  '/operations': typeof OperationsIndexRoute
  '/sales': typeof SalesIndexRoute
  '/admin/fuel-surcharge/import': typeof AdminFuelSurchargeImportRoute
  '/admin/organizations/$id': typeof AdminOrganizationsIdRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/quotes/new': typeof AdminQuotesNewRoute
  '/admin/system-logs/$id': typeof AdminSystemLogsIdRoute
  '/client/quotes/new': typeof ClientQuotesNewRoute
  '/operations/organizations/$id': typeof OperationsOrganizationsIdRoute
  '/operations/organizations': typeof OperationsOrganizationsIndexRoute
  '/operations/quotes/new': typeof OperationsQuotesNewRoute
  '/admin/addresses': typeof AdminAddressesIndexRoute
  '/admin/assistant': typeof AdminAssistantIndexRoute
  '/admin/crossdock-cost': typeof AdminCrossdockCostIndexRoute
  '/admin/delivery-cost': typeof AdminDeliveryCostIndexRoute
  '/admin/fuel-surcharge': typeof AdminFuelSurchargeIndexRoute
  '/admin/items': typeof AdminItemsIndexRoute
  '/admin/linehaul-cost': typeof AdminLinehaulCostIndexRoute
  '/admin/pickup-cost-cbm': typeof AdminPickupCostCbmIndexRoute
  '/admin/pickup-cost-pallet': typeof AdminPickupCostPalletIndexRoute
  '/admin/pickup-cost': typeof AdminPickupCostIndexRoute
  '/admin/post-code': typeof AdminPostCodeIndexRoute
  '/admin/quotes': typeof AdminQuotesIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/admin/system-logs': typeof AdminSystemLogsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/zoning': typeof AdminZoningIndexRoute
  '/client/address-book': typeof ClientAddressBookIndexRoute
  '/client/quotes': typeof ClientQuotesIndexRoute
  '/gm/quotes': typeof GmQuotesIndexRoute
  '/operations/items': typeof OperationsItemsIndexRoute
  '/operations/quotes': typeof OperationsQuotesIndexRoute
  '/sales/quotes': typeof SalesQuotesIndexRoute
  '/admin/quotes/$id/edit': typeof AdminQuotesIdEditRoute
  '/client/quotes/$id/edit': typeof ClientQuotesIdEditRoute
  '/gm/quotes/$id/edit': typeof GmQuotesIdEditRoute
  '/operations/quotes/$id/edit': typeof OperationsQuotesIdEditRoute
  '/sales/quotes/$id/edit': typeof SalesQuotesIdEditRoute
  '/admin/delivery-cost/cbm': typeof AdminDeliveryCostCbmIndexRoute
  '/admin/delivery-cost/pallet': typeof AdminDeliveryCostPalletIndexRoute
  '/admin/quotes/$id': typeof AdminQuotesIdIndexRoute
  '/admin/system-settings/cbm-bands': typeof AdminSystemSettingsCbmBandsIndexRoute
  '/admin/system-settings/general': typeof AdminSystemSettingsGeneralIndexRoute
  '/admin/system-settings/pallet-bands': typeof AdminSystemSettingsPalletBandsIndexRoute
  '/client/quotes/$id': typeof ClientQuotesIdIndexRoute
  '/gm/quotes/$id': typeof GmQuotesIdIndexRoute
  '/operations/quotes/$id': typeof OperationsQuotesIdIndexRoute
  '/sales/quotes/$id': typeof SalesQuotesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/gm': typeof GmRouteWithChildren
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/operations': typeof OperationsRouteWithChildren
  '/sales': typeof SalesRouteWithChildren
  '/terms': typeof TermsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/admin/__root': typeof Admin_rootRoute
  '/admin/addresses': typeof AdminAddressesRouteWithChildren
  '/admin/crossdock-cost': typeof AdminCrossdockCostRouteWithChildren
  '/admin/delivery-cost': typeof AdminDeliveryCostRouteWithChildren
  '/admin/fuel-surcharge': typeof AdminFuelSurchargeRouteWithChildren
  '/admin/linehaul-cost': typeof AdminLinehaulCostRouteWithChildren
  '/admin/pickup-cost': typeof AdminPickupCostRouteWithChildren
  '/admin/profile': typeof AdminProfileRoute
  '/admin/system-logs': typeof AdminSystemLogsRouteWithChildren
  '/admin/tailgate-cost': typeof AdminTailgateCostRoute
  '/admin/tailgate-cost-cbm': typeof AdminTailgateCostCbmRoute
  '/admin/tailgate-cost-pallet': typeof AdminTailgateCostPalletRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/zoning': typeof AdminZoningRouteWithChildren
  '/client/address-book': typeof ClientAddressBookRouteWithChildren
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/settings': typeof ClientSettingsRoute
  '/gm/profile': typeof GmProfileRoute
  '/operations/profile': typeof OperationsProfileRoute
  '/operations/settings': typeof OperationsSettingsRoute
  '/quotes/$quoteId': typeof QuotesQuoteIdRoute
  '/sales/profile': typeof SalesProfileRoute
  '/admin/': typeof AdminIndexRoute
  '/client/': typeof ClientIndexRoute
  '/gm/': typeof GmIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/admin/fuel-surcharge/import': typeof AdminFuelSurchargeImportRoute
  '/admin/organizations/$id': typeof AdminOrganizationsIdRoute
  '/admin/organizations/__root': typeof AdminOrganizations_rootRoute
  '/admin/quotes/$id': typeof AdminQuotesIdRouteWithChildren
  '/admin/quotes/new': typeof AdminQuotesNewRoute
  '/admin/system-logs/$id': typeof AdminSystemLogsIdRoute
  '/client/quotes/$id': typeof ClientQuotesIdRouteWithChildren
  '/client/quotes/new': typeof ClientQuotesNewRoute
  '/gm/quotes/$id': typeof GmQuotesIdRouteWithChildren
  '/operations/organizations/$id': typeof OperationsOrganizationsIdRoute
  '/operations/organizations/__root': typeof OperationsOrganizations_rootRoute
  '/operations/quotes/$id': typeof OperationsQuotesIdRouteWithChildren
  '/operations/quotes/new': typeof OperationsQuotesNewRoute
  '/sales/quotes/$id': typeof SalesQuotesIdRouteWithChildren
  '/admin/addresses/': typeof AdminAddressesIndexRoute
  '/admin/assistant/': typeof AdminAssistantIndexRoute
  '/admin/crossdock-cost/': typeof AdminCrossdockCostIndexRoute
  '/admin/delivery-cost/': typeof AdminDeliveryCostIndexRoute
  '/admin/fuel-surcharge/': typeof AdminFuelSurchargeIndexRoute
  '/admin/items/': typeof AdminItemsIndexRoute
  '/admin/linehaul-cost/': typeof AdminLinehaulCostIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/pickup-cost-cbm/': typeof AdminPickupCostCbmIndexRoute
  '/admin/pickup-cost-pallet/': typeof AdminPickupCostPalletIndexRoute
  '/admin/pickup-cost/': typeof AdminPickupCostIndexRoute
  '/admin/post-code/': typeof AdminPostCodeIndexRoute
  '/admin/quotes/': typeof AdminQuotesIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/system-logs/': typeof AdminSystemLogsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/zoning/': typeof AdminZoningIndexRoute
  '/client/address-book/': typeof ClientAddressBookIndexRoute
  '/client/quotes/': typeof ClientQuotesIndexRoute
  '/gm/quotes/': typeof GmQuotesIndexRoute
  '/operations/items/': typeof OperationsItemsIndexRoute
  '/operations/organizations/': typeof OperationsOrganizationsIndexRoute
  '/operations/quotes/': typeof OperationsQuotesIndexRoute
  '/sales/quotes/': typeof SalesQuotesIndexRoute
  '/admin/quotes/$id/edit': typeof AdminQuotesIdEditRoute
  '/client/quotes/$id/edit': typeof ClientQuotesIdEditRoute
  '/gm/quotes/$id/edit': typeof GmQuotesIdEditRoute
  '/operations/quotes/$id/edit': typeof OperationsQuotesIdEditRoute
  '/sales/quotes/$id/edit': typeof SalesQuotesIdEditRoute
  '/admin/delivery-cost/cbm/': typeof AdminDeliveryCostCbmIndexRoute
  '/admin/delivery-cost/pallet/': typeof AdminDeliveryCostPalletIndexRoute
  '/admin/quotes/$id/': typeof AdminQuotesIdIndexRoute
  '/admin/system-settings/cbm-bands/': typeof AdminSystemSettingsCbmBandsIndexRoute
  '/admin/system-settings/general/': typeof AdminSystemSettingsGeneralIndexRoute
  '/admin/system-settings/pallet-bands/': typeof AdminSystemSettingsPalletBandsIndexRoute
  '/client/quotes/$id/': typeof ClientQuotesIdIndexRoute
  '/gm/quotes/$id/': typeof GmQuotesIdIndexRoute
  '/operations/quotes/$id/': typeof OperationsQuotesIdIndexRoute
  '/sales/quotes/$id/': typeof SalesQuotesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/client'
    | '/gm'
    | '/login'
    | '/not-found'
    | '/operations'
    | '/sales'
    | '/terms'
    | '/unauthorized'
    | '/unsubscribe'
    | '/admin/addresses'
    | '/admin/crossdock-cost'
    | '/admin/delivery-cost'
    | '/admin/fuel-surcharge'
    | '/admin/linehaul-cost'
    | '/admin/pickup-cost'
    | '/admin/profile'
    | '/admin/system-logs'
    | '/admin/tailgate-cost'
    | '/admin/tailgate-cost-cbm'
    | '/admin/tailgate-cost-pallet'
    | '/admin/users'
    | '/admin/zoning'
    | '/client/address-book'
    | '/client/dashboard'
    | '/client/profile'
    | '/client/settings'
    | '/gm/profile'
    | '/operations/profile'
    | '/operations/settings'
    | '/quotes/$quoteId'
    | '/sales/profile'
    | '/admin/'
    | '/client/'
    | '/gm/'
    | '/operations/'
    | '/sales/'
    | '/admin/fuel-surcharge/import'
    | '/admin/organizations/$id'
    | '/admin/organizations'
    | '/admin/quotes/$id'
    | '/admin/quotes/new'
    | '/admin/system-logs/$id'
    | '/client/quotes/$id'
    | '/client/quotes/new'
    | '/gm/quotes/$id'
    | '/operations/organizations/$id'
    | '/operations/organizations'
    | '/operations/quotes/$id'
    | '/operations/quotes/new'
    | '/sales/quotes/$id'
    | '/admin/addresses/'
    | '/admin/assistant/'
    | '/admin/crossdock-cost/'
    | '/admin/delivery-cost/'
    | '/admin/fuel-surcharge/'
    | '/admin/items/'
    | '/admin/linehaul-cost/'
    | '/admin/organizations/'
    | '/admin/pickup-cost-cbm/'
    | '/admin/pickup-cost-pallet/'
    | '/admin/pickup-cost/'
    | '/admin/post-code/'
    | '/admin/quotes/'
    | '/admin/settings/'
    | '/admin/system-logs/'
    | '/admin/users/'
    | '/admin/zoning/'
    | '/client/address-book/'
    | '/client/quotes/'
    | '/gm/quotes/'
    | '/operations/items/'
    | '/operations/organizations/'
    | '/operations/quotes/'
    | '/sales/quotes/'
    | '/admin/quotes/$id/edit'
    | '/client/quotes/$id/edit'
    | '/gm/quotes/$id/edit'
    | '/operations/quotes/$id/edit'
    | '/sales/quotes/$id/edit'
    | '/admin/delivery-cost/cbm/'
    | '/admin/delivery-cost/pallet/'
    | '/admin/quotes/$id/'
    | '/admin/system-settings/cbm-bands/'
    | '/admin/system-settings/general/'
    | '/admin/system-settings/pallet-bands/'
    | '/client/quotes/$id/'
    | '/gm/quotes/$id/'
    | '/operations/quotes/$id/'
    | '/sales/quotes/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/not-found'
    | '/terms'
    | '/unauthorized'
    | '/unsubscribe'
    | '/admin'
    | '/admin/profile'
    | '/admin/tailgate-cost'
    | '/admin/tailgate-cost-cbm'
    | '/admin/tailgate-cost-pallet'
    | '/client/dashboard'
    | '/client/profile'
    | '/client/settings'
    | '/gm/profile'
    | '/operations/profile'
    | '/operations/settings'
    | '/quotes/$quoteId'
    | '/sales/profile'
    | '/client'
    | '/gm'
    | '/operations'
    | '/sales'
    | '/admin/fuel-surcharge/import'
    | '/admin/organizations/$id'
    | '/admin/organizations'
    | '/admin/quotes/new'
    | '/admin/system-logs/$id'
    | '/client/quotes/new'
    | '/operations/organizations/$id'
    | '/operations/organizations'
    | '/operations/quotes/new'
    | '/admin/addresses'
    | '/admin/assistant'
    | '/admin/crossdock-cost'
    | '/admin/delivery-cost'
    | '/admin/fuel-surcharge'
    | '/admin/items'
    | '/admin/linehaul-cost'
    | '/admin/pickup-cost-cbm'
    | '/admin/pickup-cost-pallet'
    | '/admin/pickup-cost'
    | '/admin/post-code'
    | '/admin/quotes'
    | '/admin/settings'
    | '/admin/system-logs'
    | '/admin/users'
    | '/admin/zoning'
    | '/client/address-book'
    | '/client/quotes'
    | '/gm/quotes'
    | '/operations/items'
    | '/operations/quotes'
    | '/sales/quotes'
    | '/admin/quotes/$id/edit'
    | '/client/quotes/$id/edit'
    | '/gm/quotes/$id/edit'
    | '/operations/quotes/$id/edit'
    | '/sales/quotes/$id/edit'
    | '/admin/delivery-cost/cbm'
    | '/admin/delivery-cost/pallet'
    | '/admin/quotes/$id'
    | '/admin/system-settings/cbm-bands'
    | '/admin/system-settings/general'
    | '/admin/system-settings/pallet-bands'
    | '/client/quotes/$id'
    | '/gm/quotes/$id'
    | '/operations/quotes/$id'
    | '/sales/quotes/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/client'
    | '/gm'
    | '/login'
    | '/not-found'
    | '/operations'
    | '/sales'
    | '/terms'
    | '/unauthorized'
    | '/unsubscribe'
    | '/admin/__root'
    | '/admin/addresses'
    | '/admin/crossdock-cost'
    | '/admin/delivery-cost'
    | '/admin/fuel-surcharge'
    | '/admin/linehaul-cost'
    | '/admin/pickup-cost'
    | '/admin/profile'
    | '/admin/system-logs'
    | '/admin/tailgate-cost'
    | '/admin/tailgate-cost-cbm'
    | '/admin/tailgate-cost-pallet'
    | '/admin/users'
    | '/admin/zoning'
    | '/client/address-book'
    | '/client/dashboard'
    | '/client/profile'
    | '/client/settings'
    | '/gm/profile'
    | '/operations/profile'
    | '/operations/settings'
    | '/quotes/$quoteId'
    | '/sales/profile'
    | '/admin/'
    | '/client/'
    | '/gm/'
    | '/operations/'
    | '/sales/'
    | '/admin/fuel-surcharge/import'
    | '/admin/organizations/$id'
    | '/admin/organizations/__root'
    | '/admin/quotes/$id'
    | '/admin/quotes/new'
    | '/admin/system-logs/$id'
    | '/client/quotes/$id'
    | '/client/quotes/new'
    | '/gm/quotes/$id'
    | '/operations/organizations/$id'
    | '/operations/organizations/__root'
    | '/operations/quotes/$id'
    | '/operations/quotes/new'
    | '/sales/quotes/$id'
    | '/admin/addresses/'
    | '/admin/assistant/'
    | '/admin/crossdock-cost/'
    | '/admin/delivery-cost/'
    | '/admin/fuel-surcharge/'
    | '/admin/items/'
    | '/admin/linehaul-cost/'
    | '/admin/organizations/'
    | '/admin/pickup-cost-cbm/'
    | '/admin/pickup-cost-pallet/'
    | '/admin/pickup-cost/'
    | '/admin/post-code/'
    | '/admin/quotes/'
    | '/admin/settings/'
    | '/admin/system-logs/'
    | '/admin/users/'
    | '/admin/zoning/'
    | '/client/address-book/'
    | '/client/quotes/'
    | '/gm/quotes/'
    | '/operations/items/'
    | '/operations/organizations/'
    | '/operations/quotes/'
    | '/sales/quotes/'
    | '/admin/quotes/$id/edit'
    | '/client/quotes/$id/edit'
    | '/gm/quotes/$id/edit'
    | '/operations/quotes/$id/edit'
    | '/sales/quotes/$id/edit'
    | '/admin/delivery-cost/cbm/'
    | '/admin/delivery-cost/pallet/'
    | '/admin/quotes/$id/'
    | '/admin/system-settings/cbm-bands/'
    | '/admin/system-settings/general/'
    | '/admin/system-settings/pallet-bands/'
    | '/client/quotes/$id/'
    | '/gm/quotes/$id/'
    | '/operations/quotes/$id/'
    | '/sales/quotes/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ClientRoute: typeof ClientRouteWithChildren
  GmRoute: typeof GmRouteWithChildren
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  OperationsRoute: typeof OperationsRouteWithChildren
  SalesRoute: typeof SalesRouteWithChildren
  TermsRoute: typeof TermsRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  QuotesQuoteIdRoute: typeof QuotesQuoteIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin/__root': {
      id: '/admin/__root'
      path: ''
      fullPath: '/admin'
      preLoaderRoute: typeof Admin_rootRouteImport
      parentRoute: typeof AdminRoute
    }
    '/operations/organizations/__root': {
      id: '/operations/organizations/__root'
      path: '/organizations'
      fullPath: '/operations/organizations'
      preLoaderRoute: typeof OperationsOrganizations_rootRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/admin/organizations/__root': {
      id: '/admin/organizations/__root'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizations_rootRouteImport
      parentRoute: typeof AdminRoute
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales': {
      id: '/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof SalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations': {
      id: '/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof OperationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gm': {
      id: '/gm'
      path: '/gm'
      fullPath: '/gm'
      preLoaderRoute: typeof GmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client': {
      id: '/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof ClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/': {
      id: '/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof SalesIndexRouteImport
      parentRoute: typeof SalesRoute
    }
    '/operations/': {
      id: '/operations/'
      path: '/'
      fullPath: '/operations/'
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/gm/': {
      id: '/gm/'
      path: '/'
      fullPath: '/gm/'
      preLoaderRoute: typeof GmIndexRouteImport
      parentRoute: typeof GmRoute
    }
    '/client/': {
      id: '/client/'
      path: '/'
      fullPath: '/client/'
      preLoaderRoute: typeof ClientIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/sales/profile': {
      id: '/sales/profile'
      path: '/profile'
      fullPath: '/sales/profile'
      preLoaderRoute: typeof SalesProfileRouteImport
      parentRoute: typeof SalesRoute
    }
    '/quotes/$quoteId': {
      id: '/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof QuotesQuoteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/settings': {
      id: '/operations/settings'
      path: '/settings'
      fullPath: '/operations/settings'
      preLoaderRoute: typeof OperationsSettingsRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/operations/profile': {
      id: '/operations/profile'
      path: '/profile'
      fullPath: '/operations/profile'
      preLoaderRoute: typeof OperationsProfileRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/gm/profile': {
      id: '/gm/profile'
      path: '/profile'
      fullPath: '/gm/profile'
      preLoaderRoute: typeof GmProfileRouteImport
      parentRoute: typeof GmRoute
    }
    '/client/settings': {
      id: '/client/settings'
      path: '/settings'
      fullPath: '/client/settings'
      preLoaderRoute: typeof ClientSettingsRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/profile': {
      id: '/client/profile'
      path: '/profile'
      fullPath: '/client/profile'
      preLoaderRoute: typeof ClientProfileRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/dashboard': {
      id: '/client/dashboard'
      path: '/dashboard'
      fullPath: '/client/dashboard'
      preLoaderRoute: typeof ClientDashboardRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/address-book': {
      id: '/client/address-book'
      path: '/address-book'
      fullPath: '/client/address-book'
      preLoaderRoute: typeof ClientAddressBookRouteImport
      parentRoute: typeof ClientRoute
    }
    '/admin/zoning': {
      id: '/admin/zoning'
      path: '/zoning'
      fullPath: '/admin/zoning'
      preLoaderRoute: typeof AdminZoningRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tailgate-cost-pallet': {
      id: '/admin/tailgate-cost-pallet'
      path: '/tailgate-cost-pallet'
      fullPath: '/admin/tailgate-cost-pallet'
      preLoaderRoute: typeof AdminTailgateCostPalletRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tailgate-cost-cbm': {
      id: '/admin/tailgate-cost-cbm'
      path: '/tailgate-cost-cbm'
      fullPath: '/admin/tailgate-cost-cbm'
      preLoaderRoute: typeof AdminTailgateCostCbmRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tailgate-cost': {
      id: '/admin/tailgate-cost'
      path: '/tailgate-cost'
      fullPath: '/admin/tailgate-cost'
      preLoaderRoute: typeof AdminTailgateCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/system-logs': {
      id: '/admin/system-logs'
      path: '/system-logs'
      fullPath: '/admin/system-logs'
      preLoaderRoute: typeof AdminSystemLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pickup-cost': {
      id: '/admin/pickup-cost'
      path: '/pickup-cost'
      fullPath: '/admin/pickup-cost'
      preLoaderRoute: typeof AdminPickupCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/linehaul-cost': {
      id: '/admin/linehaul-cost'
      path: '/linehaul-cost'
      fullPath: '/admin/linehaul-cost'
      preLoaderRoute: typeof AdminLinehaulCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fuel-surcharge': {
      id: '/admin/fuel-surcharge'
      path: '/fuel-surcharge'
      fullPath: '/admin/fuel-surcharge'
      preLoaderRoute: typeof AdminFuelSurchargeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/delivery-cost': {
      id: '/admin/delivery-cost'
      path: '/delivery-cost'
      fullPath: '/admin/delivery-cost'
      preLoaderRoute: typeof AdminDeliveryCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/crossdock-cost': {
      id: '/admin/crossdock-cost'
      path: '/crossdock-cost'
      fullPath: '/admin/crossdock-cost'
      preLoaderRoute: typeof AdminCrossdockCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/addresses': {
      id: '/admin/addresses'
      path: '/addresses'
      fullPath: '/admin/addresses'
      preLoaderRoute: typeof AdminAddressesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/sales/quotes/': {
      id: '/sales/quotes/'
      path: '/quotes'
      fullPath: '/sales/quotes/'
      preLoaderRoute: typeof SalesQuotesIndexRouteImport
      parentRoute: typeof SalesRoute
    }
    '/operations/quotes/': {
      id: '/operations/quotes/'
      path: '/quotes'
      fullPath: '/operations/quotes/'
      preLoaderRoute: typeof OperationsQuotesIndexRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/operations/organizations/': {
      id: '/operations/organizations/'
      path: '/organizations'
      fullPath: '/operations/organizations/'
      preLoaderRoute: typeof OperationsOrganizationsIndexRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/operations/items/': {
      id: '/operations/items/'
      path: '/items'
      fullPath: '/operations/items/'
      preLoaderRoute: typeof OperationsItemsIndexRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/gm/quotes/': {
      id: '/gm/quotes/'
      path: '/quotes'
      fullPath: '/gm/quotes/'
      preLoaderRoute: typeof GmQuotesIndexRouteImport
      parentRoute: typeof GmRoute
    }
    '/client/quotes/': {
      id: '/client/quotes/'
      path: '/quotes'
      fullPath: '/client/quotes/'
      preLoaderRoute: typeof ClientQuotesIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/address-book/': {
      id: '/client/address-book/'
      path: '/'
      fullPath: '/client/address-book/'
      preLoaderRoute: typeof ClientAddressBookIndexRouteImport
      parentRoute: typeof ClientAddressBookRoute
    }
    '/admin/zoning/': {
      id: '/admin/zoning/'
      path: '/'
      fullPath: '/admin/zoning/'
      preLoaderRoute: typeof AdminZoningIndexRouteImport
      parentRoute: typeof AdminZoningRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/system-logs/': {
      id: '/admin/system-logs/'
      path: '/'
      fullPath: '/admin/system-logs/'
      preLoaderRoute: typeof AdminSystemLogsIndexRouteImport
      parentRoute: typeof AdminSystemLogsRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quotes/': {
      id: '/admin/quotes/'
      path: '/quotes'
      fullPath: '/admin/quotes/'
      preLoaderRoute: typeof AdminQuotesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/post-code/': {
      id: '/admin/post-code/'
      path: '/post-code'
      fullPath: '/admin/post-code/'
      preLoaderRoute: typeof AdminPostCodeIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pickup-cost/': {
      id: '/admin/pickup-cost/'
      path: '/'
      fullPath: '/admin/pickup-cost/'
      preLoaderRoute: typeof AdminPickupCostIndexRouteImport
      parentRoute: typeof AdminPickupCostRoute
    }
    '/admin/pickup-cost-pallet/': {
      id: '/admin/pickup-cost-pallet/'
      path: '/pickup-cost-pallet'
      fullPath: '/admin/pickup-cost-pallet/'
      preLoaderRoute: typeof AdminPickupCostPalletIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pickup-cost-cbm/': {
      id: '/admin/pickup-cost-cbm/'
      path: '/pickup-cost-cbm'
      fullPath: '/admin/pickup-cost-cbm/'
      preLoaderRoute: typeof AdminPickupCostCbmIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/linehaul-cost/': {
      id: '/admin/linehaul-cost/'
      path: '/'
      fullPath: '/admin/linehaul-cost/'
      preLoaderRoute: typeof AdminLinehaulCostIndexRouteImport
      parentRoute: typeof AdminLinehaulCostRoute
    }
    '/admin/items/': {
      id: '/admin/items/'
      path: '/items'
      fullPath: '/admin/items/'
      preLoaderRoute: typeof AdminItemsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fuel-surcharge/': {
      id: '/admin/fuel-surcharge/'
      path: '/'
      fullPath: '/admin/fuel-surcharge/'
      preLoaderRoute: typeof AdminFuelSurchargeIndexRouteImport
      parentRoute: typeof AdminFuelSurchargeRoute
    }
    '/admin/delivery-cost/': {
      id: '/admin/delivery-cost/'
      path: '/'
      fullPath: '/admin/delivery-cost/'
      preLoaderRoute: typeof AdminDeliveryCostIndexRouteImport
      parentRoute: typeof AdminDeliveryCostRoute
    }
    '/admin/crossdock-cost/': {
      id: '/admin/crossdock-cost/'
      path: '/'
      fullPath: '/admin/crossdock-cost/'
      preLoaderRoute: typeof AdminCrossdockCostIndexRouteImport
      parentRoute: typeof AdminCrossdockCostRoute
    }
    '/admin/assistant/': {
      id: '/admin/assistant/'
      path: '/assistant'
      fullPath: '/admin/assistant/'
      preLoaderRoute: typeof AdminAssistantIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/addresses/': {
      id: '/admin/addresses/'
      path: '/'
      fullPath: '/admin/addresses/'
      preLoaderRoute: typeof AdminAddressesIndexRouteImport
      parentRoute: typeof AdminAddressesRoute
    }
    '/sales/quotes/$id': {
      id: '/sales/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/sales/quotes/$id'
      preLoaderRoute: typeof SalesQuotesIdRouteImport
      parentRoute: typeof SalesRoute
    }
    '/operations/quotes/new': {
      id: '/operations/quotes/new'
      path: '/quotes/new'
      fullPath: '/operations/quotes/new'
      preLoaderRoute: typeof OperationsQuotesNewRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/operations/quotes/$id': {
      id: '/operations/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/operations/quotes/$id'
      preLoaderRoute: typeof OperationsQuotesIdRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/operations/organizations/$id': {
      id: '/operations/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/operations/organizations/$id'
      preLoaderRoute: typeof OperationsOrganizationsIdRouteImport
      parentRoute: typeof OperationsRoute
    }
    '/gm/quotes/$id': {
      id: '/gm/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/gm/quotes/$id'
      preLoaderRoute: typeof GmQuotesIdRouteImport
      parentRoute: typeof GmRoute
    }
    '/client/quotes/new': {
      id: '/client/quotes/new'
      path: '/quotes/new'
      fullPath: '/client/quotes/new'
      preLoaderRoute: typeof ClientQuotesNewRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/quotes/$id': {
      id: '/client/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/client/quotes/$id'
      preLoaderRoute: typeof ClientQuotesIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/admin/system-logs/$id': {
      id: '/admin/system-logs/$id'
      path: '/$id'
      fullPath: '/admin/system-logs/$id'
      preLoaderRoute: typeof AdminSystemLogsIdRouteImport
      parentRoute: typeof AdminSystemLogsRoute
    }
    '/admin/quotes/new': {
      id: '/admin/quotes/new'
      path: '/quotes/new'
      fullPath: '/admin/quotes/new'
      preLoaderRoute: typeof AdminQuotesNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quotes/$id': {
      id: '/admin/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/admin/quotes/$id'
      preLoaderRoute: typeof AdminQuotesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/$id': {
      id: '/admin/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/admin/organizations/$id'
      preLoaderRoute: typeof AdminOrganizationsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fuel-surcharge/import': {
      id: '/admin/fuel-surcharge/import'
      path: '/import'
      fullPath: '/admin/fuel-surcharge/import'
      preLoaderRoute: typeof AdminFuelSurchargeImportRouteImport
      parentRoute: typeof AdminFuelSurchargeRoute
    }
    '/sales/quotes/$id/': {
      id: '/sales/quotes/$id/'
      path: '/'
      fullPath: '/sales/quotes/$id/'
      preLoaderRoute: typeof SalesQuotesIdIndexRouteImport
      parentRoute: typeof SalesQuotesIdRoute
    }
    '/operations/quotes/$id/': {
      id: '/operations/quotes/$id/'
      path: '/'
      fullPath: '/operations/quotes/$id/'
      preLoaderRoute: typeof OperationsQuotesIdIndexRouteImport
      parentRoute: typeof OperationsQuotesIdRoute
    }
    '/gm/quotes/$id/': {
      id: '/gm/quotes/$id/'
      path: '/'
      fullPath: '/gm/quotes/$id/'
      preLoaderRoute: typeof GmQuotesIdIndexRouteImport
      parentRoute: typeof GmQuotesIdRoute
    }
    '/client/quotes/$id/': {
      id: '/client/quotes/$id/'
      path: '/'
      fullPath: '/client/quotes/$id/'
      preLoaderRoute: typeof ClientQuotesIdIndexRouteImport
      parentRoute: typeof ClientQuotesIdRoute
    }
    '/admin/system-settings/pallet-bands/': {
      id: '/admin/system-settings/pallet-bands/'
      path: '/system-settings/pallet-bands'
      fullPath: '/admin/system-settings/pallet-bands/'
      preLoaderRoute: typeof AdminSystemSettingsPalletBandsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/system-settings/general/': {
      id: '/admin/system-settings/general/'
      path: '/system-settings/general'
      fullPath: '/admin/system-settings/general/'
      preLoaderRoute: typeof AdminSystemSettingsGeneralIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/system-settings/cbm-bands/': {
      id: '/admin/system-settings/cbm-bands/'
      path: '/system-settings/cbm-bands'
      fullPath: '/admin/system-settings/cbm-bands/'
      preLoaderRoute: typeof AdminSystemSettingsCbmBandsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quotes/$id/': {
      id: '/admin/quotes/$id/'
      path: '/'
      fullPath: '/admin/quotes/$id/'
      preLoaderRoute: typeof AdminQuotesIdIndexRouteImport
      parentRoute: typeof AdminQuotesIdRoute
    }
    '/admin/delivery-cost/pallet/': {
      id: '/admin/delivery-cost/pallet/'
      path: '/pallet'
      fullPath: '/admin/delivery-cost/pallet/'
      preLoaderRoute: typeof AdminDeliveryCostPalletIndexRouteImport
      parentRoute: typeof AdminDeliveryCostRoute
    }
    '/admin/delivery-cost/cbm/': {
      id: '/admin/delivery-cost/cbm/'
      path: '/cbm'
      fullPath: '/admin/delivery-cost/cbm/'
      preLoaderRoute: typeof AdminDeliveryCostCbmIndexRouteImport
      parentRoute: typeof AdminDeliveryCostRoute
    }
    '/sales/quotes/$id/edit': {
      id: '/sales/quotes/$id/edit'
      path: '/edit'
      fullPath: '/sales/quotes/$id/edit'
      preLoaderRoute: typeof SalesQuotesIdEditRouteImport
      parentRoute: typeof SalesQuotesIdRoute
    }
    '/operations/quotes/$id/edit': {
      id: '/operations/quotes/$id/edit'
      path: '/edit'
      fullPath: '/operations/quotes/$id/edit'
      preLoaderRoute: typeof OperationsQuotesIdEditRouteImport
      parentRoute: typeof OperationsQuotesIdRoute
    }
    '/gm/quotes/$id/edit': {
      id: '/gm/quotes/$id/edit'
      path: '/edit'
      fullPath: '/gm/quotes/$id/edit'
      preLoaderRoute: typeof GmQuotesIdEditRouteImport
      parentRoute: typeof GmQuotesIdRoute
    }
    '/client/quotes/$id/edit': {
      id: '/client/quotes/$id/edit'
      path: '/edit'
      fullPath: '/client/quotes/$id/edit'
      preLoaderRoute: typeof ClientQuotesIdEditRouteImport
      parentRoute: typeof ClientQuotesIdRoute
    }
    '/admin/quotes/$id/edit': {
      id: '/admin/quotes/$id/edit'
      path: '/edit'
      fullPath: '/admin/quotes/$id/edit'
      preLoaderRoute: typeof AdminQuotesIdEditRouteImport
      parentRoute: typeof AdminQuotesIdRoute
    }
  }
}

interface AdminAddressesRouteChildren {
  AdminAddressesIndexRoute: typeof AdminAddressesIndexRoute
}

const AdminAddressesRouteChildren: AdminAddressesRouteChildren = {
  AdminAddressesIndexRoute: AdminAddressesIndexRoute,
}

const AdminAddressesRouteWithChildren = AdminAddressesRoute._addFileChildren(
  AdminAddressesRouteChildren,
)

interface AdminCrossdockCostRouteChildren {
  AdminCrossdockCostIndexRoute: typeof AdminCrossdockCostIndexRoute
}

const AdminCrossdockCostRouteChildren: AdminCrossdockCostRouteChildren = {
  AdminCrossdockCostIndexRoute: AdminCrossdockCostIndexRoute,
}

const AdminCrossdockCostRouteWithChildren =
  AdminCrossdockCostRoute._addFileChildren(AdminCrossdockCostRouteChildren)

interface AdminDeliveryCostRouteChildren {
  AdminDeliveryCostIndexRoute: typeof AdminDeliveryCostIndexRoute
  AdminDeliveryCostCbmIndexRoute: typeof AdminDeliveryCostCbmIndexRoute
  AdminDeliveryCostPalletIndexRoute: typeof AdminDeliveryCostPalletIndexRoute
}

const AdminDeliveryCostRouteChildren: AdminDeliveryCostRouteChildren = {
  AdminDeliveryCostIndexRoute: AdminDeliveryCostIndexRoute,
  AdminDeliveryCostCbmIndexRoute: AdminDeliveryCostCbmIndexRoute,
  AdminDeliveryCostPalletIndexRoute: AdminDeliveryCostPalletIndexRoute,
}

const AdminDeliveryCostRouteWithChildren =
  AdminDeliveryCostRoute._addFileChildren(AdminDeliveryCostRouteChildren)

interface AdminFuelSurchargeRouteChildren {
  AdminFuelSurchargeImportRoute: typeof AdminFuelSurchargeImportRoute
  AdminFuelSurchargeIndexRoute: typeof AdminFuelSurchargeIndexRoute
}

const AdminFuelSurchargeRouteChildren: AdminFuelSurchargeRouteChildren = {
  AdminFuelSurchargeImportRoute: AdminFuelSurchargeImportRoute,
  AdminFuelSurchargeIndexRoute: AdminFuelSurchargeIndexRoute,
}

const AdminFuelSurchargeRouteWithChildren =
  AdminFuelSurchargeRoute._addFileChildren(AdminFuelSurchargeRouteChildren)

interface AdminLinehaulCostRouteChildren {
  AdminLinehaulCostIndexRoute: typeof AdminLinehaulCostIndexRoute
}

const AdminLinehaulCostRouteChildren: AdminLinehaulCostRouteChildren = {
  AdminLinehaulCostIndexRoute: AdminLinehaulCostIndexRoute,
}

const AdminLinehaulCostRouteWithChildren =
  AdminLinehaulCostRoute._addFileChildren(AdminLinehaulCostRouteChildren)

interface AdminPickupCostRouteChildren {
  AdminPickupCostIndexRoute: typeof AdminPickupCostIndexRoute
}

const AdminPickupCostRouteChildren: AdminPickupCostRouteChildren = {
  AdminPickupCostIndexRoute: AdminPickupCostIndexRoute,
}

const AdminPickupCostRouteWithChildren = AdminPickupCostRoute._addFileChildren(
  AdminPickupCostRouteChildren,
)

interface AdminSystemLogsRouteChildren {
  AdminSystemLogsIdRoute: typeof AdminSystemLogsIdRoute
  AdminSystemLogsIndexRoute: typeof AdminSystemLogsIndexRoute
}

const AdminSystemLogsRouteChildren: AdminSystemLogsRouteChildren = {
  AdminSystemLogsIdRoute: AdminSystemLogsIdRoute,
  AdminSystemLogsIndexRoute: AdminSystemLogsIndexRoute,
}

const AdminSystemLogsRouteWithChildren = AdminSystemLogsRoute._addFileChildren(
  AdminSystemLogsRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminZoningRouteChildren {
  AdminZoningIndexRoute: typeof AdminZoningIndexRoute
}

const AdminZoningRouteChildren: AdminZoningRouteChildren = {
  AdminZoningIndexRoute: AdminZoningIndexRoute,
}

const AdminZoningRouteWithChildren = AdminZoningRoute._addFileChildren(
  AdminZoningRouteChildren,
)

interface AdminQuotesIdRouteChildren {
  AdminQuotesIdEditRoute: typeof AdminQuotesIdEditRoute
  AdminQuotesIdIndexRoute: typeof AdminQuotesIdIndexRoute
}

const AdminQuotesIdRouteChildren: AdminQuotesIdRouteChildren = {
  AdminQuotesIdEditRoute: AdminQuotesIdEditRoute,
  AdminQuotesIdIndexRoute: AdminQuotesIdIndexRoute,
}

const AdminQuotesIdRouteWithChildren = AdminQuotesIdRoute._addFileChildren(
  AdminQuotesIdRouteChildren,
)

interface AdminRouteChildren {
  Admin_rootRoute: typeof Admin_rootRoute
  AdminAddressesRoute: typeof AdminAddressesRouteWithChildren
  AdminCrossdockCostRoute: typeof AdminCrossdockCostRouteWithChildren
  AdminDeliveryCostRoute: typeof AdminDeliveryCostRouteWithChildren
  AdminFuelSurchargeRoute: typeof AdminFuelSurchargeRouteWithChildren
  AdminLinehaulCostRoute: typeof AdminLinehaulCostRouteWithChildren
  AdminPickupCostRoute: typeof AdminPickupCostRouteWithChildren
  AdminProfileRoute: typeof AdminProfileRoute
  AdminSystemLogsRoute: typeof AdminSystemLogsRouteWithChildren
  AdminTailgateCostRoute: typeof AdminTailgateCostRoute
  AdminTailgateCostCbmRoute: typeof AdminTailgateCostCbmRoute
  AdminTailgateCostPalletRoute: typeof AdminTailgateCostPalletRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminZoningRoute: typeof AdminZoningRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminOrganizationsIdRoute: typeof AdminOrganizationsIdRoute
  AdminOrganizations_rootRoute: typeof AdminOrganizations_rootRoute
  AdminQuotesIdRoute: typeof AdminQuotesIdRouteWithChildren
  AdminQuotesNewRoute: typeof AdminQuotesNewRoute
  AdminAssistantIndexRoute: typeof AdminAssistantIndexRoute
  AdminItemsIndexRoute: typeof AdminItemsIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminPickupCostCbmIndexRoute: typeof AdminPickupCostCbmIndexRoute
  AdminPickupCostPalletIndexRoute: typeof AdminPickupCostPalletIndexRoute
  AdminPostCodeIndexRoute: typeof AdminPostCodeIndexRoute
  AdminQuotesIndexRoute: typeof AdminQuotesIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminSystemSettingsCbmBandsIndexRoute: typeof AdminSystemSettingsCbmBandsIndexRoute
  AdminSystemSettingsGeneralIndexRoute: typeof AdminSystemSettingsGeneralIndexRoute
  AdminSystemSettingsPalletBandsIndexRoute: typeof AdminSystemSettingsPalletBandsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  Admin_rootRoute: Admin_rootRoute,
  AdminAddressesRoute: AdminAddressesRouteWithChildren,
  AdminCrossdockCostRoute: AdminCrossdockCostRouteWithChildren,
  AdminDeliveryCostRoute: AdminDeliveryCostRouteWithChildren,
  AdminFuelSurchargeRoute: AdminFuelSurchargeRouteWithChildren,
  AdminLinehaulCostRoute: AdminLinehaulCostRouteWithChildren,
  AdminPickupCostRoute: AdminPickupCostRouteWithChildren,
  AdminProfileRoute: AdminProfileRoute,
  AdminSystemLogsRoute: AdminSystemLogsRouteWithChildren,
  AdminTailgateCostRoute: AdminTailgateCostRoute,
  AdminTailgateCostCbmRoute: AdminTailgateCostCbmRoute,
  AdminTailgateCostPalletRoute: AdminTailgateCostPalletRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminZoningRoute: AdminZoningRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminOrganizationsIdRoute: AdminOrganizationsIdRoute,
  AdminOrganizations_rootRoute: AdminOrganizations_rootRoute,
  AdminQuotesIdRoute: AdminQuotesIdRouteWithChildren,
  AdminQuotesNewRoute: AdminQuotesNewRoute,
  AdminAssistantIndexRoute: AdminAssistantIndexRoute,
  AdminItemsIndexRoute: AdminItemsIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminPickupCostCbmIndexRoute: AdminPickupCostCbmIndexRoute,
  AdminPickupCostPalletIndexRoute: AdminPickupCostPalletIndexRoute,
  AdminPostCodeIndexRoute: AdminPostCodeIndexRoute,
  AdminQuotesIndexRoute: AdminQuotesIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminSystemSettingsCbmBandsIndexRoute: AdminSystemSettingsCbmBandsIndexRoute,
  AdminSystemSettingsGeneralIndexRoute: AdminSystemSettingsGeneralIndexRoute,
  AdminSystemSettingsPalletBandsIndexRoute:
    AdminSystemSettingsPalletBandsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ClientAddressBookRouteChildren {
  ClientAddressBookIndexRoute: typeof ClientAddressBookIndexRoute
}

const ClientAddressBookRouteChildren: ClientAddressBookRouteChildren = {
  ClientAddressBookIndexRoute: ClientAddressBookIndexRoute,
}

const ClientAddressBookRouteWithChildren =
  ClientAddressBookRoute._addFileChildren(ClientAddressBookRouteChildren)

interface ClientQuotesIdRouteChildren {
  ClientQuotesIdEditRoute: typeof ClientQuotesIdEditRoute
  ClientQuotesIdIndexRoute: typeof ClientQuotesIdIndexRoute
}

const ClientQuotesIdRouteChildren: ClientQuotesIdRouteChildren = {
  ClientQuotesIdEditRoute: ClientQuotesIdEditRoute,
  ClientQuotesIdIndexRoute: ClientQuotesIdIndexRoute,
}

const ClientQuotesIdRouteWithChildren = ClientQuotesIdRoute._addFileChildren(
  ClientQuotesIdRouteChildren,
)

interface ClientRouteChildren {
  ClientAddressBookRoute: typeof ClientAddressBookRouteWithChildren
  ClientDashboardRoute: typeof ClientDashboardRoute
  ClientProfileRoute: typeof ClientProfileRoute
  ClientSettingsRoute: typeof ClientSettingsRoute
  ClientIndexRoute: typeof ClientIndexRoute
  ClientQuotesIdRoute: typeof ClientQuotesIdRouteWithChildren
  ClientQuotesNewRoute: typeof ClientQuotesNewRoute
  ClientQuotesIndexRoute: typeof ClientQuotesIndexRoute
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientAddressBookRoute: ClientAddressBookRouteWithChildren,
  ClientDashboardRoute: ClientDashboardRoute,
  ClientProfileRoute: ClientProfileRoute,
  ClientSettingsRoute: ClientSettingsRoute,
  ClientIndexRoute: ClientIndexRoute,
  ClientQuotesIdRoute: ClientQuotesIdRouteWithChildren,
  ClientQuotesNewRoute: ClientQuotesNewRoute,
  ClientQuotesIndexRoute: ClientQuotesIndexRoute,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

interface GmQuotesIdRouteChildren {
  GmQuotesIdEditRoute: typeof GmQuotesIdEditRoute
  GmQuotesIdIndexRoute: typeof GmQuotesIdIndexRoute
}

const GmQuotesIdRouteChildren: GmQuotesIdRouteChildren = {
  GmQuotesIdEditRoute: GmQuotesIdEditRoute,
  GmQuotesIdIndexRoute: GmQuotesIdIndexRoute,
}

const GmQuotesIdRouteWithChildren = GmQuotesIdRoute._addFileChildren(
  GmQuotesIdRouteChildren,
)

interface GmRouteChildren {
  GmProfileRoute: typeof GmProfileRoute
  GmIndexRoute: typeof GmIndexRoute
  GmQuotesIdRoute: typeof GmQuotesIdRouteWithChildren
  GmQuotesIndexRoute: typeof GmQuotesIndexRoute
}

const GmRouteChildren: GmRouteChildren = {
  GmProfileRoute: GmProfileRoute,
  GmIndexRoute: GmIndexRoute,
  GmQuotesIdRoute: GmQuotesIdRouteWithChildren,
  GmQuotesIndexRoute: GmQuotesIndexRoute,
}

const GmRouteWithChildren = GmRoute._addFileChildren(GmRouteChildren)

interface OperationsQuotesIdRouteChildren {
  OperationsQuotesIdEditRoute: typeof OperationsQuotesIdEditRoute
  OperationsQuotesIdIndexRoute: typeof OperationsQuotesIdIndexRoute
}

const OperationsQuotesIdRouteChildren: OperationsQuotesIdRouteChildren = {
  OperationsQuotesIdEditRoute: OperationsQuotesIdEditRoute,
  OperationsQuotesIdIndexRoute: OperationsQuotesIdIndexRoute,
}

const OperationsQuotesIdRouteWithChildren =
  OperationsQuotesIdRoute._addFileChildren(OperationsQuotesIdRouteChildren)

interface OperationsRouteChildren {
  OperationsProfileRoute: typeof OperationsProfileRoute
  OperationsSettingsRoute: typeof OperationsSettingsRoute
  OperationsIndexRoute: typeof OperationsIndexRoute
  OperationsOrganizationsIdRoute: typeof OperationsOrganizationsIdRoute
  OperationsOrganizations_rootRoute: typeof OperationsOrganizations_rootRoute
  OperationsQuotesIdRoute: typeof OperationsQuotesIdRouteWithChildren
  OperationsQuotesNewRoute: typeof OperationsQuotesNewRoute
  OperationsItemsIndexRoute: typeof OperationsItemsIndexRoute
  OperationsOrganizationsIndexRoute: typeof OperationsOrganizationsIndexRoute
  OperationsQuotesIndexRoute: typeof OperationsQuotesIndexRoute
}

const OperationsRouteChildren: OperationsRouteChildren = {
  OperationsProfileRoute: OperationsProfileRoute,
  OperationsSettingsRoute: OperationsSettingsRoute,
  OperationsIndexRoute: OperationsIndexRoute,
  OperationsOrganizationsIdRoute: OperationsOrganizationsIdRoute,
  OperationsOrganizations_rootRoute: OperationsOrganizations_rootRoute,
  OperationsQuotesIdRoute: OperationsQuotesIdRouteWithChildren,
  OperationsQuotesNewRoute: OperationsQuotesNewRoute,
  OperationsItemsIndexRoute: OperationsItemsIndexRoute,
  OperationsOrganizationsIndexRoute: OperationsOrganizationsIndexRoute,
  OperationsQuotesIndexRoute: OperationsQuotesIndexRoute,
}

const OperationsRouteWithChildren = OperationsRoute._addFileChildren(
  OperationsRouteChildren,
)

interface SalesQuotesIdRouteChildren {
  SalesQuotesIdEditRoute: typeof SalesQuotesIdEditRoute
  SalesQuotesIdIndexRoute: typeof SalesQuotesIdIndexRoute
}

const SalesQuotesIdRouteChildren: SalesQuotesIdRouteChildren = {
  SalesQuotesIdEditRoute: SalesQuotesIdEditRoute,
  SalesQuotesIdIndexRoute: SalesQuotesIdIndexRoute,
}

const SalesQuotesIdRouteWithChildren = SalesQuotesIdRoute._addFileChildren(
  SalesQuotesIdRouteChildren,
)

interface SalesRouteChildren {
  SalesProfileRoute: typeof SalesProfileRoute
  SalesIndexRoute: typeof SalesIndexRoute
  SalesQuotesIdRoute: typeof SalesQuotesIdRouteWithChildren
  SalesQuotesIndexRoute: typeof SalesQuotesIndexRoute
}

const SalesRouteChildren: SalesRouteChildren = {
  SalesProfileRoute: SalesProfileRoute,
  SalesIndexRoute: SalesIndexRoute,
  SalesQuotesIdRoute: SalesQuotesIdRouteWithChildren,
  SalesQuotesIndexRoute: SalesQuotesIndexRoute,
}

const SalesRouteWithChildren = SalesRoute._addFileChildren(SalesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ClientRoute: ClientRouteWithChildren,
  GmRoute: GmRouteWithChildren,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  OperationsRoute: OperationsRouteWithChildren,
  SalesRoute: SalesRouteWithChildren,
  TermsRoute: TermsRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  QuotesQuoteIdRoute: QuotesQuoteIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
